import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import UserImage from './userimage';
import PhoneStatus from './phonestatus';
import FormStatus from './formstatus';
import { Col } from 'react-bootstrap';
import ChatStatus from './chatstatus';
import SignalRService from "src/controllers/SignalRService";
import { changeJanusStatus } from 'src/redux/parametersSlice';
import ChatsService from 'src/controllers/ChatController';
import { useNavigate } from "react-router-dom";

class AgentCard extends Component {

    constructor(props) {
        super(props);
        this.callAgent = this.callAgent.bind(this);
        this.openInternal = this.openInternal.bind(this);
    }

    callAgent = (e) => {
        e.preventDefault();
        this.props.changeJanusStatus("makeCall");
        SignalRService.makeCall({
            "extension": this.props.extension,
            "userId": this.props.userId,
            "called": this.props.agent.ext
        });
    }

    openInternal = e => {
        e.preventDefault();
        ChatsService.initInternal(this.props.userId, this.props.agent.name, this.props.agent.pin, x => {
            this.props.navigate("/main/interactions/chat");
        });
    }

    render() {
        return (<Col>

            <div className="d-flex align-items-center me-2" style={{ width: "250px", padding: "5px" }} >
                <UserImage agent={this.props.agent} />
                <div className="w-100">
                    <div className="fs-7 text-dark fw-bold w-100">{this.props.agent.name}</div>
                    <div className="fs-7 text-muted fw-bold">
                        <span className="text-muted float-start">
                            {
                                (this.props.agent.ext !== this.props.extension) &&
                                <a className={""} href="/#" onClick={this.callAgent}>{this.props.agent.ext}</a>
                            }

                            {
                                (this.props.agent.ext === this.props.extension) &&
                                this.props.agent.ext
                            }
                        </span>
                        <span className="text-primary float-end">
                            <PhoneStatus agent={this.props.agent} />
                            <FormStatus agent={this.props.agent} />
                            {
                                (this.props.agent.ext !== this.props.extension && this.props.chatAgents.indexOf(this.props.agent.pin) > -1) &&
                                <a className={""} href="/#" onClick={this.openInternal}><ChatStatus agent={this.props.agent} /></a>
                            }

                            {
                                (this.props.agent.ext === this.props.extension || this.props.chatAgents.indexOf(this.props.agent.pin) === -1) &&
                                <ChatStatus agent={this.props.agent} />
                            }

                        </span>
                    </div>
                </div>
            </div>
        </Col>)
    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <AgentCard {...props} navigate={navigate} />
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        extension: state.agent.extension
    };
};
export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(WithNavigate);
